<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="ch3"> </p>
<p class="CN"><span href="#/xhtml/contents#c_ch3" title="Link target outside of Sample"><span class="Sans-B">THREE</span></span></p>
<p class="DL"><span class="Sans-B">DAY 1—FEBRUARY 6, 1982</span></p>
<p class="EX-1"><span class="ePub-I">The reversal of our patients’ symptoms has been staggering. I do not want to present our findings until we have drawn absolutely conclusive results, but we are on the precipice of obtaining a cure for Alzheimer’s. Each patient shows a complete reversal of plaque formation as well as synaptic regeneration at levels far beyond our projections. However, it is the synaptic and glial cell activity that has been the most surprising.</span></p>
<p class="EXI-1"><span class="ePub-I">One of the strangest side effects is that patients are recalling memories from early childhood and infancy. These are memories they had no recollection of, even prior to their illness. Are these memories real, and if so, why couldn’t they be accessed until now?</span></p>
<p class="EXI-1"><span class="ePub-I">We find ourselves in uncharted territory and I cannot help but ask the question: if the drug is this effective on a damaged mind, what would be its effect on a healthy one?</span></p>
<p class="EXI-1"><span class="ePub-I">This question consumes me and my impulse to try the drug has become too great. I have become my own case study and have taken several doses, reassuring myself that I am not the first scientist in history willing to use his body in an experiment.</span></p>
<p class="EXI-1"><span class="ePub-I">I have not discussed what I have done with the team yet, let alone Diana. I am worried they will think I’ve lost my mind. I plan to tell them tomorrow and perform a series of sleep studies on myself.</span></p>
<p class="EXI-1"><span class="ePub-I">I’ve decided to keep a journal of results with as much transparency as possible, to leave a trail behind so I can remember where I started and why I began. What’s happening to me now presents a truly unforeseen and confounding variable. My experiences are taking me beyond the scope of my imagination. I do not have answers. I am not even sure what the questions are.</span></p>
<p class="EXI-1"><span class="ePub-I">MB</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter3.vue?867901b8